import React, { useState, useEffect, useRef } from "react";
import { IoMdSearch } from "react-icons/io";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import Plan from "./Plan";
import Package from "../assets/images/Home/Package.svg";
import { GoDownload } from "react-icons/go";
import LoadingSpinner from "../components/LoadingSpinner";
import Pagination from "../components/Pagination";
import Plus from "../assets/images/Home/Plus.svg";
import { toast } from "react-toastify";
import { ImCross } from "react-icons/im";
import Premium from "../assets/images/Home/Premium.svg";
import Standard from "../assets/images/Home/Standard.svg";
import Lifetime from "../assets/images/New_Jul_2025/Life.svg";
import iota from "../assets/images/New_Jul_2025/iota.svg";
// 🔥 Import your PWG icon — replace path as needed
import PWGIcon from "../assets/images/New_Jul_2025/iota.svg";

const EsimStore = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const role = localStorage.getItem("role");
  const [error, setError] = useState(null);

  const [showStaticModal, setShowStaticModal] = useState(false);
  const [selectedStaticPlan, setSelectedStaticPlan] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const [isPurchasing, setIsPurchasing] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const itemsPerPage = 10;
  const apiUrl = process.env.REACT_APP_BASE_URL;
  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const [packageType, setPackageType] = useState(null);
  const [hovered, setHovered] = useState("");
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [description, setDescription] = useState("");
  const LIFETIME_PLAN_IDS = ["3129"];

  const [isPageActive, setIsPageActive] = useState(true);
  const refreshTimeoutRef = useRef(null);

  const CACHE_KEY = "esimPlansCache";
  const CACHE_VERSION = "v3";
  const CACHE_DURATION = 30 * 60 * 1000;
  const isMobile = window.innerWidth < 768;

  // ─────────────────────────────────────────────
  // 🔥 PWG STATIC PLANS
  // ─────────────────────────────────────────────
  const PWG_STATIC_PLANS = [
    {
      planid: "pwg-1",
      country: "USA",
      data: "Unlimited",
      validity: "30 Days",
      plancode: "PWG-USA-001",
      sellingcost: "39.99",
      operatorname: "PWG Network",
      plan_type: "PWG_plan",
      plan_Class: "data",
      plan_datatype: "",
      recharge: 1,
      remarks: "Unlimited high-speed PWG data for USA",
      connectivity: "5G",
      countries_covered: "USA",
      apn: "pwg.fast.net",
      activation: "SIM Provision",
      coverage: "Local",
      isStatic: true,
      isPWG: true,
    },
    {
      planid: "pwg-2",
      country: "Global",
      data: "50GB",
      validity: "30 Days",
      plancode: "PWG-GLB-001",
      sellingcost: "89.99",
      operatorname: "PWG Network",
      plan_type: "PWG_plan",
      plan_Class: "data",
      plan_datatype: "",
      recharge: 1,
      remarks: "Global roaming PWG plan — 150+ countries",
      connectivity: "5G",
      countries_covered: "150+ Countries",
      apn: "pwg.global.net",
      activation: "SIM Provision",
      coverage: "International",
      isStatic: true,
      isPWG: true,
    },
    {
      planid: "pwg-3",
      country: "Europe",
      data: "30GB",
      validity: "15 Days",
      plancode: "PWG-EU-001",
      sellingcost: "49.99",
      operatorname: "PWG Network",
      plan_type: "PWG_plan",
      plan_Class: "data",
      plan_datatype: "",
      recharge: 0,
      remarks: "Europe coverage — 30+ countries included",
      connectivity: "4G/5G",
      countries_covered: "30+ European Countries",
      apn: "pwg.eu.net",
      activation: "SIM Provision",
      coverage: "Regional",
      isStatic: true,
      isPWG: true,
    },
    {
      planid: "pwg-4",
      country: "Asia",
      data: "20GB",
      validity: "14 Days",
      plancode: "PWG-AS-001",
      sellingcost: "34.99",
      operatorname: "PWG Network",
      plan_type: "PWG_plan",
      plan_Class: "data",
      plan_datatype: "",
      recharge: 0,
      remarks: "Asia-Pacific PWG coverage plan",
      connectivity: "4G",
      countries_covered: "15+ Asian Countries",
      apn: "pwg.asia.net",
      activation: "SIM Provision",
      coverage: "Regional",
      isStatic: true,
      isPWG: true,
    },
    {
      planid: "pwg-5",
      country: "UK",
      data: "15GB",
      validity: "7 Days",
      plancode: "PWG-UK-001",
      sellingcost: "19.99",
      operatorname: "PWG Network",
      plan_type: "PWG_plan",
      plan_Class: "voicedata",
      plan_datatype: "",
      recharge: 0,
      remarks: "UK PWG plan with calls & texts",
      connectivity: "5G",
      countries_covered: "UK",
      apn: "pwg.uk.net",
      activation: "SIM Provision",
      coverage: "Local",
      isStatic: true,
      isPWG: true,
    },
  ];

  const STATIC_PLANS = {
    Lifetime: [
      {
        planid: "static-lifetime-1",
        country: "USA",
        data: "Unlimited",
        validity: "Lifetime",
        plancode: "LT-USA-001",
        sellingcost: "299.99",
        operatorname: "T-Mobile",
        plan_type: "Lifetime_plan",
        plan_Class: "lifetime",
        plan_datatype: "",
        recharge: 0,
        remarks: "Lifetime unlimited data plan for USA",
        connectivity: "5G",
        countries_covered: "USA",
        apn: "fast.tmobile.com",
        activation: "SIM Provision",
        coverage: "Local",
        isStatic: true,
      },
      {
        planid: "static-lifetime-2",
        country: "Global",
        data: "100GB/Month",
        validity: "Lifetime",
        plancode: "LT-GLB-001",
        sellingcost: "499.99",
        operatorname: "T-Mobile",
        plan_type: "Lifetime_plan",
        plan_Class: "lifetime",
        plan_datatype: "",
        recharge: 0,
        remarks: "Lifetime global roaming plan",
        connectivity: "5G",
        countries_covered: "150+ Countries",
        apn: "global.tmobile.com",
        activation: "SIM Provision",
        coverage: "International",
        isStatic: true,
      },
      {
        planid: "static-lifetime-3",
        country: "Europe",
        data: "50GB/Month",
        validity: "Lifetime",
        plancode: "LT-EU-001",
        sellingcost: "399.99",
        operatorname: "Euro Connect",
        plan_type: "Lifetime_plan",
        plan_Class: "lifetime",
        plan_datatype: "",
        recharge: 0,
        remarks: "Lifetime Europe coverage plan",
        connectivity: "5G",
        countries_covered: "30+ European Countries",
        apn: "eu.connect.com",
        activation: "SIM Provision",
        coverage: "Regional",
        isStatic: true,
      },
    ],
    Premium: {
      voicedata: [
        {
          planid: "static-premium-vd-1",
          country: "USA",
          data: "50GB",
          validity: "30 Days",
          plancode: "PM-VD-USA-001",
          sellingcost: "49.99",
          operatorname: "T-Mobile",
          plan_type: "Premium_plan",
          plan_Class: "voicedata",
          plan_datatype: "",
          recharge: 1,
          remarks: "Unlimited calls & texts included",
          connectivity: "5G",
          countries_covered: "USA",
          apn: "fast.tmobile.com",
          activation: "SIM Provision",
          coverage: "Local",
          isStatic: true,
        },
        {
          planid: "static-premium-vd-2",
          country: "UK",
          data: "30GB",
          validity: "30 Days",
          plancode: "PM-VD-UK-001",
          sellingcost: "39.99",
          operatorname: "T-Mobile",
          plan_type: "Premium_plan",
          plan_Class: "voicedata",
          plan_datatype: "",
          recharge: 1,
          remarks: "100 mins calls & 100 SMS included",
          connectivity: "5G",
          countries_covered: "UK",
          apn: "web.vodafone.co.uk",
          activation: "SIM Provision",
          coverage: "Local",
          isStatic: true,
        },
      ],
      data: [
        {
          planid: "static-premium-d-1",
          country: "USA",
          data: "100GB",
          validity: "30 Days",
          plancode: "PM-D-USA-001",
          sellingcost: "59.99",
          operatorname: "T-Mobile",
          plan_type: "Premium_plan",
          plan_Class: "data",
          plan_datatype: "",
          recharge: 1,
          remarks: "High-speed data only plan",
          connectivity: "5G",
          countries_covered: "USA",
          apn: "fast.tmobile.com",
          activation: "SIM Provision",
          coverage: "Local",
          isStatic: true,
        },
      ],
    },
    Standard: {
      fixed: [
        {
          planid: "static-standard-f-1",
          country: "USA",
          data: "10GB",
          validity: "7 Days",
          plancode: "ST-F-USA-001",
          sellingcost: "19.99",
          operatorname: "AT&T",
          plan_type: "Standard_plan",
          plan_Class: "",
          plan_datatype: "",
          recharge: 0,
          remarks: "Basic fixed data plan",
          connectivity: "4G",
          countries_covered: "USA",
          apn: "phone",
          activation: "SIM Provision",
          coverage: "Local",
          isStatic: true,
        },
        {
          planid: "static-standard-f-2",
          country: "Canada",
          data: "5GB",
          validity: "7 Days",
          plancode: "ST-F-CA-001",
          sellingcost: "14.99",
          operatorname: "Rogers",
          plan_type: "Standard_plan",
          plan_Class: "",
          plan_datatype: "",
          recharge: 0,
          remarks: "Budget friendly data plan",
          connectivity: "4G",
          countries_covered: "Canada",
          apn: "ltemobile.apn",
          activation: "SIM Provision",
          coverage: "Local",
          isStatic: true,
        },
      ],
      Daily: [
        {
          planid: "static-standard-d-1",
          country: "USA",
          data: "1GB",
          validity: "Daily",
          plancode: "ST-DY-USA-001",
          sellingcost: "4.99",
          operatorname: "T-Mobile",
          plan_type: "Standard_plan",
          plan_Class: "",
          plan_datatype: "Daily",
          recharge: 0,
          remarks: "Daily unlimited with fair usage",
          connectivity: "4G",
          countries_covered: "USA",
          apn: "fast.tmobile.com",
          activation: "SIM Provision",
          coverage: "Local",
          isStatic: true,
        },
      ],
    },
  };

  const getStaticPlans = () => {
    if (selectedPackageType === "PWG") {
      return PWG_STATIC_PLANS;
    } else if (selectedPackageType === "Lifetime") {
      return STATIC_PLANS.Lifetime;
    } else if (selectedPackageType === "Premium") {
      return STATIC_PLANS.Premium[packageType] || STATIC_PLANS.Premium.voicedata;
    } else if (selectedPackageType === "Standard") {
      const key = packageType === "" ? "fixed" : packageType;
      return STATIC_PLANS.Standard[key] || STATIC_PLANS.Standard.fixed;
    }
    return [];
  };

  const handleStaticPlanClick = (plan) => {
    setSelectedStaticPlan(plan);
    setActiveTab("overview");
    setShowStaticModal(true);
  };

  const handleStaticPurchase = () => {
    setIsPurchasing(true);
    setTimeout(() => {
      setIsPurchasing(false);
      setShowStaticModal(false);
      setShowSuccessModal(true);
    }, 2000);
  };

  const handleSuccessOk = () => {
    setShowSuccessModal(false);
    navigate("/SimMangement");
  };

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "Payaspergo") {
      setSelectedPackageType("Standard");
      setPackageType("");
    } else {
      setSelectedPackageType("Premium");
      setPackageType("voicedata");
    }
  }, []);

  const premiumPackageTypes = ["voicedata", "data"];
  const standardPackageTypes = ["", "Daily"];

  useEffect(() => {
    let visibilityHandler;

    const loadPlans = async () => {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        try {
          const { data, timestamp, version } = JSON.parse(cached);
          if (version === CACHE_VERSION && Date.now() - timestamp < CACHE_DURATION) {
            setPlans(data);
            if (isPageActive) scheduleBackgroundRefresh();
            return;
          }
        } catch (e) {}
      }
      await fetchPlans(true);
    };

    const scheduleBackgroundRefresh = () => {
      if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
      refreshTimeoutRef.current = setTimeout(() => {
        if (isPageActive) fetchPlans(false);
      }, 10000);
    };

    const fetchPlans = async (showLoading = true) => {
      if (showLoading) setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const partnerCode = localStorage.getItem("partnerCode");
        const response = await fetch(
          `${apiUrl}ESIM/Get_all_plans?flag=1&PartnerCode=${partnerCode}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data.isSuccess) {
          const sortedPlans = data.getallplan.sort((a, b) =>
            a.country.localeCompare(b.country)
          );
          localStorage.setItem(
            CACHE_KEY,
            JSON.stringify({ data: sortedPlans, timestamp: Date.now(), version: CACHE_VERSION })
          );
          if (!showLoading && isPageActive) scheduleBackgroundRefresh();
          setPlans(sortedPlans);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
        setError("Failed to load plans. Using cached data.");
      } finally {
        if (showLoading) setIsLoading(false);
      }
    };

    const handleVisibilityChange = () => {
      setIsPageActive(!document.hidden);
      if (!document.hidden && plans.length > 0) {
        fetchPlans(false);
        scheduleBackgroundRefresh();
      } else if (document.hidden && refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };

    visibilityHandler = () => handleVisibilityChange();
    document.addEventListener("visibilitychange", visibilityHandler);
    loadPlans();

    return () => {
      document.removeEventListener("visibilitychange", visibilityHandler);
      if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    const handleFocus = () => {};
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [plans.length]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredPlans = plans.filter((plan) => {
    // PWG tab always uses static — skip API plans entirely
    if (selectedPackageType === "PWG") return false;

    const isLifetimePlan = LIFETIME_PLAN_IDS.includes(String(plan.planid));
    if (selectedPackageType === "Lifetime") return isLifetimePlan;
    if (isLifetimePlan) return false;

    const isPremiumPlan =
      plan.plan_type === "Premium_plan" &&
      plan.plan_Class === packageType &&
      plan.country.toLowerCase().includes(searchQuery.toLowerCase());

    const isStandardPlan =
      plan.plan_type === "Standard_plan" &&
      (packageType === "" ? plan.plan_datatype === "" : plan.plan_datatype === packageType) &&
      plan.country.toLowerCase().includes(searchQuery.toLowerCase());

    return isPremiumPlan || isStandardPlan;
  });

  // 🔥 PWG always uses its own static list; others fall back to static only when API is empty
  const displayPlans =
    selectedPackageType === "PWG"
      ? PWG_STATIC_PLANS.filter((p) =>
          p.country.toLowerCase().includes(searchQuery.toLowerCase())
        )
      : filteredPlans.length > 0
      ? filteredPlans
      : getStaticPlans();

  const isShowingStaticPlans =
    selectedPackageType === "PWG" || filteredPlans.length === 0;

  const totalPages = Math.ceil(displayPlans.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPlans = displayPlans.slice(indexOfFirstItem, indexOfLastItem);

  const handleBuyClick = (plan) => {
    if (plan.isStatic) {
      handleStaticPlanClick(plan);
      return;
    }
    localStorage.setItem("planCode", plan.plancode);
    localStorage.setItem("plan_id", plan.planid);
    setSelectedPlan(plan);
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);

  const downloadCSV = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const partnerCode = localStorage.getItem("partnerCode");
      if (!token) { setError("No token found. Please log in."); return; }
      const response = await fetch(
        `${apiUrl}ESIM/Get_all_plans?flag=1&PartnerCode=${partnerCode}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }
      );
      const data = await response.json();
      if (data.isSuccess) {
        let { getallplan } = data;
        getallplan = getallplan.sort((a, b) => a.country.localeCompare(b.country));
        const header = "Country,Data,Validity,Portal Price,plan_Class,plan_type,connectivity,plancode,countries_covered\n";
        const rows = getallplan
          .map((plan) => {
            const portalPrice = parseFloat(plan.sellingcost);
            return `${plan.country},${plan.data === "" ? "Unlimited" : plan.data},${plan.validity},$${portalPrice.toFixed(2)},${plan.plan_Class},${plan.plan_type},${plan.connectivity},${plan.plancode},"${plan.countries_covered}"`;
          })
          .join("\n");
        const blob = new Blob([header + rows], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "plans.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const currentPackageOptions =
    selectedPackageType === "Premium"
      ? premiumPackageTypes
      : selectedPackageType === "Standard"
      ? standardPackageTypes.map((t) => (t === "" || t === null ? "fixed" : t))
      : [];

  const addToCart = (plan) => {
    if (plan.isStatic) {
      toast.info("This is a sample plan. Real plans will be available soon!");
      return;
    }
    const existing = JSON.parse(localStorage.getItem("cartPlans") || "[]");
    if (existing.some((p) => p.plancode === plan.plancode)) {
      toast.error("This plan is already in the cart.");
      return;
    }
    if (existing.length >= 10) {
      toast.error("You can only add up to 10 plans to the cart.");
      return;
    }
    localStorage.setItem("cartPlans", JSON.stringify([...existing, { ...plan, quantity: plan.quantity || 1 }]));
    toast.success("Plan added to cart!");
  };

  const handleHover = (e, type) => {
    setHovered(type);
    setCursorPosition({ x: e?.clientX || 0, y: e?.clientY || 0 });
    const map = {
      voicedata: "High-speed plans with local number, calls and texts.",
      data: "High-speed, low-latency plans with fixed or unlimited data.",
      fixed: "Fixed data plans with low latency and recharge option.",
      Daily: "Daily unlimited plans with speed cap after fair usage.",
    };
    setDescription(map[type] || "");
  };

  const getCountriesCount = (plan) => {
    if (plan.countries_covered?.includes("+")) {
      const match = plan.countries_covered.match(/(\d+)/);
      return match ? match[1] + "+" : "1";
    }
    return "1";
  };

  // ─────────────────────────────────────────────
  // 🔥 PWG accent colors (purple-gold theme)
  // ─────────────────────────────────────────────
  const pwgGradient = "from-[#4a1b8a] to-[#7c3aed]";
  const pwgAccent = "#7c3aed";
  const pwgLight = "bg-purple-50";
  const pwgBorder = "border-purple-400";
  const pwgText = "text-purple-700";
  const pwgBadgeBg = "bg-purple-100";

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
      )}

      {/* STATIC / PWG PLAN PREVIEW MODAL */}
      {showStaticModal && selectedStaticPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div className="bg-white w-full max-w-[700px] rounded-xl shadow-2xl overflow-hidden max-h-[90vh] overflow-y-auto">

            {/* Header — purple for PWG, navy for others */}
            <div
              className={`bg-gradient-to-r ${
                selectedStaticPlan.isPWG ? pwgGradient : "from-[#3E436D] to-[#5a5f8f]"
              } text-white p-6 relative`}
            >
              <button
                onClick={() => { setShowStaticModal(false); setSelectedStaticPlan(null); }}
                className="absolute right-4 top-4 text-xl hover:bg-white/20 rounded-full w-8 h-8 flex items-center justify-center transition"
              >
                ✕
              </button>

              {/* Badge */}
              <div
                className={`absolute left-4 top-4 text-xs px-3 py-1 rounded-full font-bold ${
                  selectedStaticPlan.isPWG
                    ? "bg-purple-200 text-purple-900"
                    : "bg-yellow-400 text-yellow-900"
                }`}
              >
                {selectedStaticPlan.isPWG ? "PWG PLAN" : "SAMPLE PLAN"}
              </div>

              <div className="text-center mt-6">
                <div className="flex justify-center mb-3">
                  <img
                    src={`https://www.airhubapp.jp/assets/flags/${selectedStaticPlan.country}.svg`}
                    alt={selectedStaticPlan.country}
                    className="w-16 h-16 rounded-full border-4 border-white/30 shadow-lg"
                    onError={(e) => { e.target.src = "https://via.placeholder.com/64x64?text=🌍"; }}
                  />
                </div>
                <h2 className="text-2xl font-bold">{selectedStaticPlan.country} eSIM Plan</h2>
                <p className="text-sm text-white/80 mt-1">
                  {selectedStaticPlan.isPWG ? "PWG Network — Stay connected worldwide" : "Stay connected worldwide"}
                </p>
                <div className="flex justify-center gap-4 mt-6">
                  {[
                    { label: "Data", value: selectedStaticPlan.data || "Unlimited" },
                    { label: "Validity", value: selectedStaticPlan.validity },
                    { label: "Countries", value: getCountriesCount(selectedStaticPlan) },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-white/20 backdrop-blur px-6 py-3 rounded-xl">
                      <p className="font-bold text-xl">{value}</p>
                      <p className="text-xs text-white/70">{label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex justify-around p-4 border-b bg-gray-50">
              {["overview", "features", "information"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`font-semibold capitalize transition ${
                    activeTab === tab
                      ? `border-b-2 pb-1 ${selectedStaticPlan.isPWG ? "text-purple-700 border-purple-600" : "text-[#3E436D] border-[#3E436D]"}`
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  {tab === "information" ? "More Information" : tab}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {activeTab === "overview" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[
                    {
                      icon: "📍", title: "Plan Coverage",
                      content: <p className="text-gray-700">{selectedStaticPlan.coverage || "Local"}</p>,
                    },
                    {
                      icon: "📱", title: "Plan Type",
                      content: <p className="text-gray-700 capitalize">{selectedStaticPlan.plan_Class || "Data"}</p>,
                    },
                    {
                      icon: "🌐", title: "Network Configuration",
                      content: (
                        <div className="space-y-1 text-gray-700">
                          <p><span className="text-gray-500">Operator:</span> {selectedStaticPlan.operatorname}</p>
                          <p><span className="text-gray-500">APN:</span> {selectedStaticPlan.apn || "auto"}</p>
                          <p><span className="text-gray-500">Network:</span> {selectedStaticPlan.connectivity}</p>
                        </div>
                      ),
                    },
                    {
                      icon: "📋", title: "Plan Information",
                      content: (
                        <div className="space-y-1 text-gray-700">
                          <p><span className="text-gray-500">Plan Code:</span> {selectedStaticPlan.plancode}</p>
                          <p><span className="text-gray-500">Activation:</span> {selectedStaticPlan.activation || "SIM Provision"}</p>
                          <p><span className="text-gray-500">Device:</span> iOS & Android</p>
                        </div>
                      ),
                    },
                  ].map(({ icon, title, content }) => (
                    <div key={title} className="bg-gradient-to-br from-gray-50 to-gray-100 p-4 rounded-xl border">
                      <p className={`font-semibold mb-2 ${selectedStaticPlan.isPWG ? "text-purple-700" : "text-[#3E436D]"}`}>
                        {icon} {title}
                      </p>
                      {content}
                    </div>
                  ))}
                </div>
              )}

              {activeTab === "features" && (
                <div className="space-y-4">
                  <div className={`p-4 rounded-xl border ${selectedStaticPlan.isPWG ? "bg-purple-50 border-purple-200" : "bg-green-50 border-green-200"}`}>
                    <p className={`font-semibold mb-2 ${selectedStaticPlan.isPWG ? "text-purple-800" : "text-green-800"}`}>
                      ✨ Key Features
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                      <li>High-speed {selectedStaticPlan.connectivity} connectivity</li>
                      <li>{selectedStaticPlan.data || "Unlimited"} data allowance</li>
                      {selectedStaticPlan.plan_Class === "voicedata" && (
                        <>
                          <li>Voice calls included</li>
                          <li>SMS messaging included</li>
                        </>
                      )}
                      {selectedStaticPlan.isPWG && <li>PWG Network exclusive benefits</li>}
                      <li>Easy activation via QR code</li>
                      <li>24/7 customer support</li>
                    </ul>
                  </div>
                  <div className="bg-blue-50 p-4 rounded-xl border border-blue-200">
                    <p className="font-semibold text-blue-800 mb-2">📝 Remarks</p>
                    <p className="text-gray-700">{selectedStaticPlan.remarks}</p>
                  </div>
                </div>
              )}

              {activeTab === "information" && (
                <div className="space-y-4">
                  <div className="bg-purple-50 p-4 rounded-xl border border-purple-200">
                    <p className="font-semibold text-purple-800 mb-2">🌍 Coverage Area</p>
                    <p className="text-gray-700">{selectedStaticPlan.countries_covered}</p>
                  </div>
                  <div className="bg-orange-50 p-4 rounded-xl border border-orange-200">
                    <p className="font-semibold text-orange-800 mb-2">⚡ Renewal</p>
                    <p className="text-gray-700">
                      {selectedStaticPlan.recharge === 1
                        ? "This plan supports renewal/recharge"
                        : "One-time purchase, no renewal required"}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-xl border">
                    <p className="font-semibold text-gray-800 mb-2">📌 Important Notes</p>
                    <ul className="list-disc list-inside text-gray-600 text-sm space-y-1">
                      <li>eSIM compatible devices only</li>
                      <li>Data speeds may vary by location</li>
                      <li>Plan activates upon first use</li>
                      <li>Hotspot/tethering supported</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* Bottom Actions */}
            <div className="p-6 bg-gray-50 border-t">
              <div className="flex flex-wrap justify-center gap-3 mb-4">
                <input className="border px-4 py-2 rounded-full" placeholder="Enter Zip Code" />
              </div>
              <button
                onClick={handleStaticPurchase}
                disabled={isPurchasing}
                className={`bg-gradient-to-r ${
                  selectedStaticPlan.isPWG ? pwgGradient : "from-[#3E436D] to-[#5a5f8f]"
                } text-white px-6 py-3 rounded-full w-full font-bold text-lg shadow-lg hover:shadow-xl transition disabled:opacity-70 flex items-center justify-center`}
              >
                {isPurchasing ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Processing...
                  </>
                ) : (
                  `Buy Now - $${selectedStaticPlan.sellingcost}`
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SUCCESS MODAL */}
      {showSuccessModal && selectedStaticPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div className="bg-white w-full max-w-[400px] rounded-2xl shadow-2xl overflow-hidden text-center">
            <div className="bg-gradient-to-r from-green-400 to-green-500 p-8">
              <div className="w-20 h-20 bg-white rounded-full mx-auto flex items-center justify-center">
                <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <div className="p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Success!</h2>
              <p className="text-gray-600 mb-6">SIM purchased successfully! 🎉</p>
              <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={`https://www.airhubapp.jp/assets/flags/${selectedStaticPlan.country}.svg`}
                    alt=""
                    className="w-10 h-10 rounded-full"
                    onError={(e) => { e.target.src = "https://via.placeholder.com/40x40?text=🌍"; }}
                  />
                  <div>
                    <p className="font-bold text-gray-800">{selectedStaticPlan.country} Plan</p>
                    <p className="text-sm text-gray-500">{selectedStaticPlan.plancode}</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <p><span className="text-gray-500">Data:</span> {selectedStaticPlan.data || "Unlimited"}</p>
                  <p><span className="text-gray-500">Validity:</span> {selectedStaticPlan.validity}</p>
                  <p><span className="text-gray-500">Price:</span> ${selectedStaticPlan.sellingcost}</p>
                  <p><span className="text-gray-500">Network:</span> {selectedStaticPlan.connectivity}</p>
                </div>
              </div>
              <button
                onClick={handleSuccessOk}
                className="bg-gradient-to-r from-[#3E436D] to-[#5a5f8f] text-white px-8 py-3 rounded-full font-bold text-lg w-full shadow-lg hover:shadow-xl transition"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── MAIN LAYOUT ── */}
      <div className="flex flex-col gap-4 w-full p-2">
        <div className="flex flex-col sm:flex-row justify-between gap-3 w-full">

          {/* Plan Type Tabs */}
          <div className="flex flex-row justify-start gap-3 flex-wrap">
            {["Premium", "Standard", "Lifetime", "PWG"].map((type) => {
              const role = localStorage.getItem("role");
              if (role === "Payaspergo" && type === "Premium") return null;

              // 🔥 PWG tab styling
              const isPWGTab = type === "PWG";
              const isActive = selectedPackageType === type;

              return (
                <div
                  key={type}
                  onClick={() => {
                    setSelectedPackageType(type);
                    setCurrentPage(1);
                    if (type === "Standard") setPackageType("");
                    else if (type === "Premium") setPackageType("voicedata");
                    else if (type === "Lifetime") setPackageType("lifetime");
                    else if (type === "PWG") setPackageType("pwg");
                  }}
                  onMouseEnter={(e) => handleHover(e, type)}
                  onMouseLeave={() => setHovered("")}
                  className={`rounded-xl sm:rounded-3xl flex flex-row items-center justify-center px-4 py-2 border shadow-sm transition-all duration-150 cursor-pointer
                    ${
                      isActive
                        ? isPWGTab
                          ? "bg-white text-black font-bold border-purple-400 shadow-lg"
                          : "bg-white text-black font-bold border-[#83b1ab] shadow-lg"
                        : "bg-[#f5f8fa] text-[#718EBF] border-transparent"
                    }
                  `}
                  style={{ minWidth: "130px" }}
                >
                  <div className="flex-shrink-0">
                    <img
                      src={
                        type === "Premium" ? Premium
                        : type === "Lifetime" ? Lifetime
                        : type === "PWG" ? PWGIcon
                        : Standard
                      }
                      className={`p-2 w-8 h-8 ${
                        type === "Premium" ? "bg-[#e7ffee]"
                        : type === "Lifetime" ? "bg-[#ffeed7]"
                        : type === "PWG" ? "bg-purple-100"
                        : "bg-[#d9e4f4]"
                      } rounded-full`}
                      alt={type}
                    />
                  </div>
                  <div className="ml-2 flex flex-col items-start">
                    <span
                      className={`text-base sm:text-xl font-semibold ${
                        type === "Premium" ? "text-black"
                        : type === "Lifetime" ? "text-[#d48b00]"
                        : type === "PWG" ? "text-purple-700"
                        : "text-[#6d8bbb]"
                      }`}
                    >
                      {type === "Premium" ? "Premium Plans"
                        : type === "Lifetime" ? "Lifetime Plans"
                        : type === "PWG" ? "PWG Plans"
                        : "Standard Plans"}
                    </span>
                    <span
                      className={`text-xs sm:text-sm mt-1 hidden md:block ${
                        type === "Premium" ? "text-[#3E436D]"
                        : type === "Lifetime" ? "text-[#b08d2e]"
                        : type === "PWG" ? "text-purple-400"
                        : "text-[#a8c0e8]"
                      }`}
                    >
                      {type === "Premium" ? "Best Value"
                        : type === "Lifetime" ? "One-time payment"
                        : type === "PWG" ? "PWG Network"
                        : "Basic Packs"}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Search */}
          <div className="w-full mt-4 sm:mt-0 sm:w-32 rounded-xl flex-shrink-0">
            <div className="relative">
              <input
                type="text"
                placeholder="Search Countries"
                className="w-full rounded-xl bg-white h-10 pl-11 pr-4 text-sm border-2 border-gray-300 focus:ring-2 focus:ring-[#3E436D] transition"
                value={searchQuery}
                onChange={handleSearch}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                <IoMdSearch size={20} className="text-gray-500" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {description && (
        <div
          style={{
            position: "absolute",
            top: cursorPosition.y + 10,
            left: cursorPosition.x + 10,
            backgroundColor: "#f1f1f1",
            padding: "8px",
            borderRadius: "6px",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            zIndex: 9999,
            minWidth: "120px",
          }}
          className="text-sm text-gray-700"
        >
          {description}
        </div>
      )}

      {/* Sub-tabs — hidden for Lifetime and PWG */}
      {selectedPackageType !== "Lifetime" && selectedPackageType !== "PWG" && (
        <div className="flex space-x-8 p-6 mt-5 rounded-lg bg-white">
          {currentPackageOptions.map((type) => (
            <div
              key={type}
              onClick={() => { setPackageType(type === "fixed" ? "" : type); setCurrentPage(1); }}
              onMouseEnter={(e) => handleHover(e, type)}
              onMouseLeave={() => { setHovered(""); setDescription(""); }}
              className={`cursor-pointer text-lg font-bold ${
                packageType === (type === "fixed" ? "" : type)
                  ? "text-[#105255] border-b-4 border-[#3E436D]"
                  : "text-[#8ca3cb]"
              }`}
            >
              {type === "fixed" ? "Fixed Data"
                : type === "voicedata" ? "Voice + Data"
                : type.charAt(0).toUpperCase() + type.slice(1)}
            </div>
          ))}
        </div>
      )}

      {/* Plans Table */}
      {(plans.length > 0 || isShowingStaticPlans) && (
        <div className="p-2 border border-gray-300 shadow-md rounded-lg bg-white">
          <div className="flex flex-row gap-4 mb-4">
            <div className="flex flex-1 items-center">
              <img src={Package} alt="package" className="w-8 h-8 mb-1" />
              <span className="ml-3 text-2xl text-black font-bold">Packages</span>

              {/* 🔥 PWG badge */}
              {selectedPackageType === "PWG" && (
                <span className="ml-3 px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full font-medium">
                  PWG Network Plans
                </span>
              )}
              {isShowingStaticPlans && selectedPackageType !== "PWG" && (
                <span className="ml-3 px-3 py-1 bg-yellow-100 text-yellow-800 text-sm rounded-full font-medium animate-pulse">
                  ✨ Sample Plans - Coming Soon
                </span>
              )}
            </div>
            <button
              onClick={downloadCSV}
              className="px-4 py-3 text-[#105255] rounded-lg font-bold flex items-center justify-center space-x-2 border border-[#105255] shadow-md hover:bg-[#f0f8f8] transition"
            >
              <GoDownload size={24} />
              <span className="text-base">Export</span>
            </button>
          </div>

          {/* Desktop Table */}
          <div className="overflow-x-auto hidden md:block">
            <table className="w-full rounded-lg shadow-lg bg-white">
              <thead className="sticky top-0 bg-gray-200">
                <tr className="border-b">
                  <th className="text-center p-3">Country/Region</th>
                  <th className="text-center p-3">Data</th>
                  <th className="text-center p-3">Validity</th>
                  {selectedPackageType === "Premium" && packageType === "voicedata" && (
                    <th className="text-center p-3">Voice</th>
                  )}
                  <th className="text-center p-3">Plan Code</th>
                  {role === "Partner" && <th className="text-center p-3">Price</th>}
                  {selectedPackageType === "Premium" && (
                    <th className="text-center p-3">Renewal</th>
                  )}
                  <th className="text-center p-3">Operator</th>
                  <th className="text-center p-3">Add to Cart</th>
                  <th className="text-center p-3">Details</th>
                </tr>
              </thead>
              <tbody>
                {currentPlans.length > 0 ? (
                  currentPlans.map((plan) => (
                    <tr
                      key={plan.planid}
                      className={`border-b hover:bg-gray-100 cursor-pointer transition ${
                        plan.isPWG
                          ? "bg-gradient-to-r from-purple-50 to-violet-50"
                          : plan.isStatic
                          ? "bg-gradient-to-r from-yellow-50 to-orange-50"
                          : ""
                      }`}
                      onClick={() => handleBuyClick(plan)}
                    >
                      <td className="text-center">
                        <div className="flex justify-start ml-11 items-center">
                          <img
                            src={`https://www.airhubapp.jp/assets/flags/${plan.country}.svg`}
                            alt={`${plan.country} flag`}
                            className="w-8 h-8 mr-2"
                            onError={(e) => { e.target.src = "https://via.placeholder.com/32x32?text=🌍"; }}
                          />
                          <span style={{ lineHeight: "2" }}>{plan.country}</span>
                          {plan.isPWG && (
                            <span className="ml-2 text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full font-bold">
                              PWG
                            </span>
                          )}
                          {plan.isStatic && !plan.isPWG && (
                            <span className="ml-2 text-xs bg-yellow-400 text-yellow-900 px-2 py-0.5 rounded-full font-bold">
                              SAMPLE
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="text-center p-1">
                        {plan.data || "Unlimited"}{plan.plan_datatype ? `/${plan.plan_datatype}` : ""}
                      </td>
                      <td className="text-center p-1">{plan.validity}</td>
                      {selectedPackageType === "Premium" && packageType === "voicedata" && (
                        <td className="text-center p-1">
                          <div className="flex items-center justify-center gap-x-2 relative">
                            <img src={Plus} alt="Plus" className="flex-shrink-0" />
                            <div className="relative group flex-shrink-0">
                              <img src={iota} alt="iota" className="cursor-pointer" />
                              <div className="absolute bottom-full p-2 mb-2 hidden group-hover:block bg-[#3E436D] text-white text-xs z-10 whitespace-nowrap rounded">
                                {plan.remarks}
                              </div>
                            </div>
                          </div>
                        </td>
                      )}
                      <td className="text-center p-1">{plan.plancode}</td>
                      {role === "Partner" && (
                        <td className="text-center p-3 px-5">${plan.sellingcost}</td>
                      )}
                      {selectedPackageType === "Premium" && (
                        <td className="text-center p-1">
                          {plan.recharge == 1
                            ? <div className="flex justify-center"><img src={Plus} alt="Plus" /></div>
                            : "-"}
                        </td>
                      )}
                      <td className="text-center p-1">{plan.operatorname}</td>
                      <td className="text-center">
                        <button
                          className={`rounded-2xl items-center px-3 py-2 m-1 border-2 focus:outline-none transition ${
                            plan.isPWG
                              ? "text-purple-700 border-purple-400 bg-purple-50 hover:bg-purple-100"
                              : plan.isStatic
                              ? "text-yellow-700 border-yellow-500 bg-yellow-50 hover:bg-yellow-100"
                              : "text-[#3E436D]"
                          }`}
                          style={{
                            outline: plan.isPWG
                              ? "2px solid #a855f7"
                              : plan.isStatic
                              ? "2px solid #eab308"
                              : "2px solid #3E436D",
                          }}
                          onClick={(e) => { e.stopPropagation(); addToCart(plan); }}
                        >
                          {plan.isPWG || plan.isStatic ? "Coming Soon" : "Add to cart"}
                        </button>
                      </td>
                      <td className="text-center">
                        <button
                          className={`rounded-lg items-center p-3 m-1 text-white font-semibold transition ${
                            plan.isPWG
                              ? "bg-gradient-to-r from-purple-600 to-violet-600 hover:from-purple-700 hover:to-violet-700"
                              : plan.isStatic
                              ? "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600"
                              : "bg-[#3E436D] hover:bg-[#2d3250]"
                          }`}
                          onClick={(e) => { e.stopPropagation(); handleBuyClick(plan); }}
                        >
                          {plan.isPWG ? "Preview" : plan.isStatic ? "Preview" : "View Details"}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center py-10 text-gray-500">
                      No plans available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
          </div>

          {/* Mobile Card View */}
          <div className="w-full px-3 py-5 bg-gray-50 md:hidden">
            {selectedPackageType === "PWG" && (
              <div className="bg-purple-100 border border-purple-400 text-purple-800 px-4 py-3 rounded-xl mb-4 text-center shadow">
                <span className="font-bold">PWG Network Plans</span>
              </div>
            )}
            {isShowingStaticPlans && selectedPackageType !== "PWG" && (
              <div className="bg-gradient-to-r from-yellow-100 to-orange-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded-xl mb-4 text-center shadow">
                <span className="font-bold">✨ Sample Plans</span> - Real plans coming soon!
              </div>
            )}
            <div className="flex flex-col gap-4">
              {currentPlans.length > 0 ? (
                currentPlans.map((plan) => (
                  <div
                    key={plan.planid}
                    className={`bg-white shadow-2xl rounded-3xl flex flex-col relative px-4 pt-6 pb-6 ${
                      plan.isPWG ? "border-2 border-purple-400" : plan.isStatic ? "border-2 border-yellow-400" : ""
                    }`}
                  >
                    <div
                      className={`h-2 w-full rounded-t-3xl absolute top-0 left-0 bg-gradient-to-r ${
                        plan.isPWG
                          ? "from-purple-500 to-violet-500"
                          : plan.isStatic
                          ? "from-yellow-400 to-orange-400"
                          : "from-[#3E436D] to-[#3edba6]"
                      }`}
                    />
                    {plan.isPWG && (
                      <div className="absolute top-4 right-4 bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full font-bold">
                        PWG
                      </div>
                    )}
                    {plan.isStatic && !plan.isPWG && (
                      <div className="absolute top-4 right-4 bg-yellow-400 text-yellow-900 text-xs px-2 py-1 rounded-full font-bold animate-pulse">
                        SAMPLE
                      </div>
                    )}
                    <div className="flex items-center p-4">
                      <img
                        src={`https://www.airhubapp.jp/assets/flags/${plan.country}.svg`}
                        alt=""
                        className="w-10 h-10 rounded-full mr-3 shadow"
                        onError={(e) => { e.target.src = "https://via.placeholder.com/40x40?text=🌍"; }}
                      />
                      <span className="font-bold text-lg text-gray-800">{plan.country}</span>
                    </div>
                    <div className="flex justify-between items-center mt-2 mb-2 border-b pb-2">
                      <span className="text-lg text-[#3E436D] font-semibold">
                        {plan.data || "Unlimited"}{plan.plan_datatype ? `/${plan.plan_datatype}` : ""}
                      </span>
                      <span className="text-[#3E436D] font-semibold">{plan.validity}</span>
                    </div>
                    <div className="flex justify-between items-center pt-2">
                      <span className="text-xs text-gray-400">Operator:</span>
                      <span>{plan.operatorname}</span>
                    </div>
                    <div className="flex justify-between items-center pt-2">
                      <span className="text-xs text-gray-400">Renewal:</span>
                      <span>
                        {plan.recharge === 1
                          ? <img src={Plus} alt="Plus" className="inline w-4 h-4 mx-1" />
                          : "-"}
                      </span>
                    </div>
                    <div className="flex justify-between mt-4">
                      <button
                        className={`rounded-2xl px-4 py-2 border-2 transition ${
                          plan.isPWG
                            ? "text-purple-700 border-purple-400 bg-purple-50"
                            : plan.isStatic
                            ? "text-yellow-700 border-yellow-500 bg-yellow-50"
                            : "text-[#3E436D] border-[#3E436D] hover:bg-[#e6f9f5]"
                        }`}
                        onClick={() => addToCart(plan)}
                      >
                        {plan.isPWG || plan.isStatic ? "Coming Soon" : "Add to Cart"}
                      </button>
                      <button
                        className={`rounded-lg px-4 py-2 text-white font-bold shadow-lg transition ${
                          plan.isPWG
                            ? "bg-gradient-to-r from-purple-600 to-violet-600"
                            : plan.isStatic
                            ? "bg-gradient-to-r from-yellow-500 to-orange-500"
                            : "bg-[#3E436D]"
                        }`}
                        onClick={() => handleBuyClick(plan)}
                      >
                        ${plan.sellingcost} Preview
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-400 py-10">No plans available</div>
              )}
            </div>
            <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
          </div>

          {/* Modal for real plans */}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={{
              overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
              content: {
                width: isMobile ? "92%" : "50%",
                margin: "auto",
                padding: "0px",
                borderRadius: "12px",
                height: isMobile ? "95vh" : "90vh",
                inset: "50% auto auto 50%",
                transform: "translate(-50%, -50%)",
              },
            }}
          >
            <div className="absolute top-4 right-5 flex justify-center items-center">
              <button onClick={closeModal} className="text-white"><ImCross size={20} /></button>
            </div>
            {selectedPlan && <Plan plan={selectedPlan} closeModal={closeModal} />}
          </Modal>
        </div>
      )}
    </>
  );
};

export default EsimStore;